
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutor-on-demand/blog",
      function () {
        return require("private-next-pages/tutor-on-demand/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutor-on-demand/blog"])
      });
    }
  